import script from "./IframePlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./IframePlayer.vue?vue&type=script&setup=true&lang=js"

import "./IframePlayer.vue?vue&type=style&index=0&id=5182f8f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5182f8f0"]])

export default __exports__